import { Overlay } from '@angular/cdk/overlay';
import {
    Component,
    OnDestroy,
    OnInit,
    Signal,
    WritableSignal,
    computed,
    signal,
} from '@angular/core';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { CostObject } from 'app/api';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import { CostObjectsService } from 'app/modules/data-module/dictionary/cost-objects/cost-objects.service';
import { Subject, takeUntil } from 'rxjs';
import {
    GridViewsModule,
    TableColumnDef,
} from '../../../../../../../projects/grid-views/src/public-api';

@Component({
    selector: 'select-file-link-dialog',
    imports: [GridViewsModule],
    templateUrl: './select-cost-object-dialog.component.html',
    styleUrl: './select-cost-object-dialog.component.scss',
    providers: [
        {
            provide: MAT_SELECT_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.reposition(),
            deps: [Overlay],
        },
    ],
})
export class SelectCostObjectDialogComponent
    extends DialogBuilderComponent<any>
    implements OnInit, OnDestroy
{
    private destroy$ = new Subject<void>();

    displayedColumns: WritableSignal<Array<TableColumnDef>> = signal([]);
    dataSource: Signal<MatTableDataSource<CostObject>>;
    selection: WritableSignal<any[]> = signal([]);

    constructor(private service: CostObjectsService) {
        super();

        this.service
            .getCostObjects()
            .pipe(takeUntil(this.destroy$))
            .subscribe(res => {});

        this.displayedColumns.set([
            {
                columnName: 'Controlling Area',
                columnKey: 'controllingArea',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Cost Object',
                columnKey: 'costObject',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Type',
                columnKey: 'type',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Name',
                columnKey: 'name',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Description',
                columnKey: 'description',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Responsible',
                columnKey: 'responsible',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Category',
                columnKey: 'category',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Hierarchy',
                columnKey: 'hierarchy',
                contentType: 'boolean',
                enableSorting: true,
            },
            {
                columnName: 'Plant',
                columnKey: 'plant',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Functional Area',
                columnKey: 'functionalArea',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Currency',
                columnKey: 'currency',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Profit center',
                columnKey: 'profitCenter',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Metadata',
                columnKey: 'metadata',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Cost object group',
                columnKey: 'costObjectGroup',
                contentType: 'string',
                enableSorting: true,
            },
            {
                columnName: 'Cost object group text',
                columnKey: 'costObjectGroupText',
                contentType: 'string',
                enableSorting: true,
            },
        ]);

        this.dataSource = computed(
            () => new MatTableDataSource(this.service.state()) ?? new MatTableDataSource([])
        );
    }

    override ngOnInit(): void {
        super.ngOnInit();
        setTimeout(() => {
            this.selection.set(this.componentData.selection);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onRowSelected($event: any): void {
        if (!$event[0]) {
            return;
        }
        this.selection.set($event);

        this.service.current = $event[0];
    }
}
